<app-header></app-header>

<ion-content>
  <app-loading [hidden]="!isLoadingAvailable" [isFinishing]="isLayoutLoaded"></app-loading>
  <ion-router-outlet (activate)='isLayoutLoaded = true' (stackEvents)="onChangeStack($event)"
                     id="main-content"></ion-router-outlet>
</ion-content>
